import React from "react";
import Editor from "componentes/editor";
import {
  Button,
  Col,
  Row,
  Card,
  CardBody,
  CardHeader
} from 'reactstrap';

import {
  MdSend,
} from 'react-icons/lib/md';

const Comentario = ({
  processo: {
    comentarios = [],
    id: processoId,
    situacao = {}
  },
  enviar
}) => {
  return <Card className="card-comentarios" tag="fieldset">
    <CardHeader tag="legend">
      Comentários
    </CardHeader>
    <CardBody>
      {
        !situacao.fim &&
        <Row>
          <Col sm={12}>
            <Editor pequeno placeholder="Incluir comentario..."/>
          </Col>
        </Row>
      }
      {
        !situacao.fim &&
        <Row>
          <Col sm={12} className="text-right">
            <Button size="sm" color="secondary" onClick={enviar}><MdSend />{' '}Enviar</Button>
          </Col>
        </Row>
      }
      {
        comentarios.map(({ autor: { nome }, texto, datahora }, i) =>
          <Row className="border-bottom" key={i}>
            {/*<Col sm={1}><Avatar style={{ marginTop: "30px" }} /></Col>*/}
            <Col sm={12}>
              <p>
                <span className="comentario">{i +1}. </span>
                <span className="autor-comentario">{nome}</span>
                <span className="comentario"> - {new Date(datahora).toLocaleString()}</span>
              </p>
              <Editor conteudo={texto} somenteLeitura />
            </Col>
          </Row>
        )
      }
    </CardBody>
  </Card>
}

export default Comentario;


// WEBPACK FOOTER //
// ./src/componentes/Comentario.js